<template>
    <p-modal v-if="display">
        <div slot="content">
            <div class="title">
                <div v-if="isNotServiceArea">所在地區不再服務範圍內</div>
                <div v-else-if="type === 'empty'">請輸入您的送達地址</div>
                <div v-else-if="type === 'GPS' || type === 'address'">請確認地址是否正確</div>
                <div v-else-if="type === 'distance'">提醒您</div>
            </div>
            <div class="subtitle">
                <div v-if="isNotServiceArea">請嘗試其他地址</div>
                <div v-else-if="type === 'empty'">系統會自動搜尋附近店家</div>
                <div v-else-if="type === 'GPS' || type === 'address'">{{ address.city + address.district + address.road }}</div>
                <div v-else-if="type === 'distance'">您目前所在位置與輸入的送達位置不同</div>
            </div>
        </div>
        <div slot="buttons" v-if="isNotServiceArea" class="buttons">
            <div class="cancel button" @click="onCancel">
                取消
            </div>
            <div class="confirm button" @click="onEditAddress">
                輸入地址
            </div>
        </div>
        <div slot="buttons" v-else-if="type === 'empty'" class="buttons">
            <div class="cancel button" @click="onCancel">
                取消
            </div>
            <div class="confirm button" @click="onConfirm">
                輸入地址
            </div>
        </div>
        <div slot="buttons" v-else-if="type === 'GPS' || type === 'address'" class="buttons">
            <div class="cancel button" @click="onEditAddress">
                編輯地址
            </div>
            <div class="confirm button" @click="onConfirm">
                正確
            </div>
        </div>
        <div slot="buttons" v-else-if="type === 'distance'" class="buttons">
            <div class="confirm button one" @click="onCancel">
                好
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';
    import * as R from 'ramda'
    import { loaded } from 'vue2-google-maps'

    export default {
        name: 'GPSModal',
        components: {
            'p-modal': Modal,
        },
        data() {
            return {
                type: null,
                lat: 0,
                lng: 0,
                display: false,
                address: {},
                isNotServiceArea: false,
            };
        },
        methods: {
            parseGPS() {
                this.geocoder.geocode({
                    location: {lat: this.lat, lng: this.lng}
                }, (results, status) => {
                    if (status === 'OK') {
                        let result = results[0];
                        this.address = this.parseAddressComponents(result.address_components);
                        this.address.latitude = result.geometry.location.lat();
                        this.address.longitude = result.geometry.location.lng();
                        this.inWhitelist();
                    } else {
                        this.address = null;
                    }
                });
            },
            onEditAddress() {
                this.display = false;
                this.$emit('onConfirm', {
                    type: 'edit',
                    address: this.address,
                });
            },
            onConfirm() {
                this.display = false;
                this.$emit('onConfirm', {
                    type: this.type,
                    address: this.address,
                });
            },
            onCancel() {
                this.display = false;
                this.$emit('onCancel');
            },
            show(type, lat = 0, lng = 0, address = null) {
                this.type = type;
                this.lat = lat;
                this.lng = lng;
                this.display = true;

                if (this.type === 'address') {
                    this.address = address;
                }

                if (this.type === 'GPS') {
                    this.parseGPS();
                }
            },
            inWhitelist() {
                let city = this.address.city;
                let district = this.address.district;
                let validateCity = ['臺北市', '台北市', '新北市', '桃園市'];
                let validateDistrict = ['Lake district', '松山區', '信義區', '大安區', '中正區', '萬華區', '大同區', '中山區', '士林區', '南港區', '文山區', '三重區', '中和區', '永和區', '板橋區', '新店區', '內湖區', '松山鎮', '桃園區', '八德區'];

                district = district.replace('区', '區');

                if (R.indexOf(city)(validateCity) < 0 || R.indexOf(district)(validateDistrict) < 0) {
                    this.isNotServiceArea = true;
                    this.address = {};
                }
            },
            parseAddressComponents(components) {
                let city = components.find(data => {
                    return data.types.indexOf('administrative_area_level_1') >= 0;
                });
                let district = components.find(data => {
                    return data.types.indexOf('administrative_area_level_3') >= 0;
                });
                let road = components.find(data => {
                    return data.types.indexOf('route') >= 0;
                });
                let number = components.find(data => {
                    return data.types.indexOf('street_number') >= 0;
                });
                if (number && ! number.long_name.includes('號')) {
                    number.long_name = number.long_name + '號';
                }

                return {
                    city: city ? city.long_name : '',
                    district: district ? district.long_name : '',
                    road: (road ? road.long_name : '') + (number ? number.long_name : ''),
                }
            },
        },
        mounted() {
            loaded.then(() => {
                this.geocoder = new window.google.maps.Geocoder();
            });
        }
    };
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;
    }

    .subtitle {
        color: rgba(120,120,120,1);
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        margin-top: 5px;

        span {
            &.red {
                color: #F44336;
                font-weight: 500;
            }
        }
    }

    .buttons {
        display: flex;

        .button {
            width: calc(50% - 1px);
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            padding: 12px 0;

            &.one {
                width: 100%;
            }

            &.cancel {
                color: rgba(155,155,155,1);
            }

            &.confirm {
                color: #009D1A;
            }

            &:first-child {
                border-right: solid 1px rgba(221,221,221,1);
            }
        }
    }
</style>
